import { PrintChecksCIBDropdownType } from 'pages/VendorsTablePage/components/PrintChecks/types';

export const printChecksCIBDropdownData: PrintChecksCIBDropdownType[] = [
  {
    accountNumber: '2021',
    accountCompany: '1',
    accountName: 'CHASE BANK',
    postingDescriptionRequired: true,
    printerName: '1',
    index: 0
  },
  {
    accountNumber: '2041',
    accountCompany: '2',
    accountName: 'CREDIT CARD CLEARING',
    postingDescriptionRequired: false,
    printerName: '2',
    index: 1
  }
];
